import tw from "tailwind-styled-components";
import { NextImage } from "../../elements";

export const ServiceExampleGridWrapper = tw.div`
  flex
  flex-col
  gap-4

  desktop:grid
  desktop:grid-cols-3
  desktop:gap-6
`;

export const Image = tw(NextImage)`
  hidden desktop:block
  w-full
  h-[160px]
  object-cover
  rounded-3xl

  desktop:h-[460px]
  ${({ $span }) => $span && "desktop:col-span-2"}
`;

export const PersonWrapperDesktop = tw.div`
  hidden

  desktop:block
`;

export const PersonWrapperMobile = tw.div`
  desktop:hidden
`;
